import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { Filter } from './Filter';
import { FilterPanelSkeleton } from './CollapsibleToggle';
import { SortDropdown } from '../sorting/SortDropdown';
import styles from './FilterPanel.module.scss';
export function FilterPanel({ filters, loading = false, onFilterChange, onResetToCollection, isOpen, onClose, sortOptions, onSortChange, totalProductCount, currentSort, }) {
    const [selectedSort, setSelectedSort] = useState(currentSort || '');
    // Update selectedSort when currentSort changes
    useEffect(() => {
        setSelectedSort(currentSort || '');
    }, [currentSort]);
    // Control body overflow when mobile filter panel opens/closes
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            // Force iOS Safari to recalculate layout when filter panel opens
            if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                setTimeout(() => {
                    // Force layout recalculation for all filter toggles
                    const filterToggles = document.querySelectorAll('[data-open="true"] .collapsible');
                    filterToggles.forEach((toggle) => {
                        const content = toggle.querySelector('.content');
                        if (content) {
                            // Force reflow
                            content.style.display = 'none';
                            content.offsetHeight;
                            content.style.display = '';
                        }
                    });
                }, 100);
            }
        }
        else {
            document.body.style.overflow = '';
        }
        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);
    const handleMobileSort = (sort) => {
        setSelectedSort(sort);
        onSortChange(sort);
    };
    const handleFilterChange = (filterId, value) => {
        onFilterChange(filterId, value);
    };
    const handleClose = () => {
        document.body.style.overflow = '';
        onClose();
    };
    const clearFilters = () => {
        onResetToCollection();
        handleClose();
    };
    // Create filter objects with current selection state
    const currentFilters = filters;
    return (h(Fragment, null,
        h("div", { className: styles.filterPanel }, loading && filters.length === 0 ? (h(FilterPanelSkeleton, { filterCount: 5 })) : (currentFilters.map((filter, index) => (h(Filter, { key: filter.id, filter: filter, onFilterChange: handleFilterChange, isFirst: index === 0 }))))),
        h("div", { className: styles.mobileFilterPanel, "data-open": isOpen, onClick: (e) => {
                if (e.target === e.currentTarget) {
                    handleClose();
                }
            } },
            h("div", { className: styles.filterPanelContent },
                h("div", { className: styles.filterPanelMobileHeader },
                    h("div", { className: styles.filterPanelMobileTitle }, "Filters"),
                    h("button", { onClick: handleClose, className: styles.closeButton },
                        h("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            h("rect", { width: "24", height: "1", transform: "matrix(0.707105 0.707108 -0.707105 0.707108 1 0)", fill: "#262525" }),
                            h("rect", { width: "24", height: "1", transform: "matrix(0.707105 -0.707108 0.707105 0.707108 0 17)", fill: "#262525" })))),
                h("div", { className: styles.mobileSortContainer },
                    h(SortDropdown, { options: sortOptions, onChange: handleMobileSort, totalProductCount: totalProductCount, variant: "mobile", currentSort: selectedSort })),
                loading && filters.length === 0 ? (h(FilterPanelSkeleton, { filterCount: 5 })) : (currentFilters.map((filter, index) => (h(Filter, { key: filter.id, filter: filter, onFilterChange: handleFilterChange, isFirst: index === 0 })))),
                h("div", { className: styles.mobileFilterActions },
                    h("button", { onClick: handleClose, className: styles.applyButton }, "Apply"),
                    h("button", { onClick: clearFilters, className: styles.clearButton }, "Clear All Filters"))))));
}
